var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCarrito(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 236,
    height: 235,
    viewBox: "0 0 236 235",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M206.6 164.9H70.1C66.9 164.9 64.2 162.6 63.6 159.5L36.7 13.2H6.6C3 13.2 0 10.2 0 6.6C0 3 3 0 6.6 0H42.2C45.4 0 48.1 2.3 48.7 5.4L75.6 151.7H206.6C210.2 151.7 213.2 154.7 213.2 158.3C213.2 161.9 210.3 164.9 206.6 164.9Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M198.1 132.6H65.6C62 132.6 59 129.6 59 126C59 122.4 62 119.4 65.6 119.4H193.5L220 47.2H77C73.4 47.2 70.4 44.2 70.4 40.6C70.4 37 73.4 34 77 34H229.4C231.5 34 233.6 35.1 234.8 36.8C236 38.6 236.3 40.8 235.6 42.8L204.3 128.2C203.4 130.9 200.9 132.6 198.1 132.6Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M79.8001 234.201C65.4001 234.201 53.6001 222.401 53.6001 208.001C53.6001 193.601 65.4001 181.801 79.8001 181.801C94.2001 181.801 106 193.601 106 208.001C106 222.401 94.3001 234.201 79.8001 234.201ZM79.8001 194.901C72.6001 194.901 66.8001 200.701 66.8001 207.901C66.8001 215.101 72.6001 220.901 79.8001 220.901C87.0001 220.901 92.8001 215.001 92.8001 207.901C92.8001 200.801 87.0001 194.901 79.8001 194.901Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M193.9 234.201C179.5 234.201 167.7 222.401 167.7 208.001C167.7 193.601 179.5 181.801 193.9 181.801C208.3 181.801 220.1 193.601 220.1 208.001C220.1 222.401 208.3 234.201 193.9 234.201ZM193.9 194.901C186.7 194.901 180.9 200.701 180.9 207.901C180.9 215.101 186.7 220.901 193.9 220.901C201.1 220.901 206.9 215.001 206.9 207.901C206.9 200.801 201.1 194.901 193.9 194.901Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarrito);
export default __webpack_public_path__ + "static/media/carrito.18aacf4452a7b9c898c60a16c3bbc1f4.svg";
export { ForwardRef as ReactComponent };